class MMProductFilter extends HTMLElement {
  constructor() {
    super();
    this.container = document.getElementById(this.dataset.container);
    this.addEventListener('change', this.onChange.bind(this));
  }

  onChange(event) {
    if (event.target.type !== 'radio' || !this.container) return;

    this.container.querySelectorAll('[data-filter-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.filterPanel !== event.target.value;
    });
  }
}

customElements.define('mm-product-filter', MMProductFilter);
